import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    aboutFinishRaceEntrantsList: {
    data: []
  },
};

export const aboutFinishRaceEntrantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_ABOUT_FINISH_RACE_ENTRANTS:
      return {
        ...state,
        aboutFinishRaceEntrantsList: action.payload,
      };
    default:
      return state;
  }
};
